import React from "react";
import { format, isValid, parse, parseISO } from "date-fns";

const excelEpoch = new Date(Date.UTC(1899, 11, 30));

export const getCurrentFormattedDate = () =>
  `${format(new Date(), "yyyy-MM-dd")}T${format(new Date(), "HH:mm:ss.SSS")}Z`;

export const formatDate = (dateString, dateFormat) => {
  return isValid(new Date(dateString))
    ? format(new Date(dateString), dateFormat)
    : "";
};

export const parseExcelDateToISO = (value, dateFormat = "yyyy-MM-dd") => {
  if (typeof value === "number") {
    const date = new Date(excelEpoch.getTime() + value * 86400000);
    return isValid(date) ? format(date, dateFormat) : "";
  }

  if (typeof value === "string") {
    let date = parse(value, "dd-MM-yyyy", new Date());

    if (!isValid(date)) {
      date = parseISO(value);

      if (!isValid(date)) {
        date = parse(value, "dd/MM/yyyy", new Date());
      }
    }
    return isValid(date) ? format(date, dateFormat) : "";
  }

  if (value instanceof Date) {
    return isValid(value) ? format(value, dateFormat) : "";
  }

  return "";
};
